import { DocumentNode, gql } from "@apollo/client";
import { APICall } from "../api_helper";

export const LIST_INPUT_ELEMENTS = gql`
  query listInputElements($session: String!) {
    listInputElements(session: $session) {
      id
      name
    }
  }
`;

export const LIST_SOMEDAY_MAYBE_ELEMENTS = gql`
  query listSomedayMaybeElements($session: String!) {
    listSomedayMaybeElements(session: $session) {
      id
      name
    }
  }
`;

export const LIST_REFERENCE_LIBRARY_ELEMENTS: DocumentNode = gql`
  query listReferenceLibraryElements($session: String!) {
    listReferenceLibraryElements(session: $session) {
      id
      name
      body
      type
      physicalLibraryLocation {
        name
        id
      }
      elements {
        name
        id
        type
      }
    }
  }
`;

export const LIST_NEXT_ACTIONS = gql`
  query listNextActions($session: String!) {
    listNextActions(session: $session) {
      name
      priority
      id
      locationId
      location {
        name
        id
      }
      meeting {
        name
        id
      }
      meetingId
      projectId
      blockedById
      organizationId
      personId
      person {
        name
        id
      }
      organization {
        name
        id
      }
      topItemOfDay
      blockedBy {
        name
        id
      }
      blocks {
        name
        id
      }
      minuteEstimate
    }
  }
`;

export const LIST_UNDATED_NEXT_ACTIONS = gql`
  query listUndatedNextActions($session: String!) {
    listUndatedNextActions(session: $session) {
      name
      id
      locationId
      location {
        name
        id
      }
      project {
        name
        id
      }
      projectId
      organizationId
      personId
      organization {
        name
        id
      }
      person {
        name
        id
      }
      topItemOfDay
      blockedBy {
        name
        id
      }
      blocks {
        name
        id
      }
    }
  }
`;

export const LIST_PEOPLE = gql`
  query listPeople($session: String!) {
    listPeople(session: $session) {
      id
      name
      organizations {
        name
        id
      }
    }
  }
`;

export const LIST_DATED_NEXT_ACTIONS = gql`
  query listDatedNextActions($session: String!) {
    listDatedNextActions(session: $session) {
      name
      id
      year
      month
      day
    }
  }
`;

export const LIST_MEETINGS = gql`
  query listMeetings($session: String!) {
    listMeetings(session: $session) {
      id
      name
    }
  }
`;

export const LIST_ORGANIZATIONS = gql`
  query listOrganizations($session: String!) {
    listOrganizations(session: $session) {
      id
      name
      parentOrganization {
        name
        id
      }
      childOrganizations {
        name
        id
      }
    }
  }
`;

export const LIST_NEXT_ACTIONS_ON_DATE = gql`
  query listNextActionsOnDate($session: String!, $day: CalendarDayInput!) {
    listNextActionsOnDate(session: $session, day: $day) {
      name
      id
      locationId
      location {
        name
        id
      }
      project {
        name
        id
      }
      meeting {
        name
        id
      }
      meetingId
      projectId
      day
      month
      year
      hour
      minute
      topItemOfDay
    }
  }
`;

export const LIST_MEETINGS_ON_DATE = gql`
  query listMeetingsOnDate($session: String!, $day: CalendarDayInput!) {
    listMeetingsOnDate(session: $session, day: $day) {
      name
      id
      date {
        year
        month
        day
      }
      project {
        name
        id
      }
      organizationsAttending {
        name
        id
      }
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
    }
  }
`;

export const LIST_SETTINGS = gql`
  query listSettings($session: String!) {
    listSettings(session: $session)
  }
`;

export const LIST_MEETING_ITINERARY_OF_MEETING = gql`
  query listMeetingItineraryOfMeeting($session: String!, $meetingId: Int!) {
    listMeetingItineraryOfMeeting(session: $session, meetingId: $meetingId) {
      id
      name
    }
  }
`;

export const LIST_STATISTICS = gql`
  query listStatistics($session: String!) {
    listStatistics(session: $session) {
      user_count
      active_in_last_365_days
      active_in_last_90_days
      active_in_last_30_days
      active_in_last_7_days
    }
  }
`;

export const LIST_PROJECT_TEMPLATES = gql`
  query listProjectTemplates($session: String!) {
    listProjectTemplates(session: $session) {
      name
      id
      projectTemplateVariables {
        name
        id
      }
      projectTemplateElements {
        name
        id
      }
    }
  }
`;

export const LIST_HABITS = gql`
  query listHabits($session: String!) {
    listHabits(session: $session) {
      name
      id
      habitItems {
        name
        id
      }
    }
  }
`;

export const LIST_LISTS = gql`
  query listLists($session: String!) {
    listLists(session: $session) {
      name
      id
      listItems {
        name
        id
        status
      }
    }
  }
`;

export const LIST_PHYSICAL_LIBRARY_LOCATIONS = gql`
  query listPhysicalLibraryLocations($session: String!) {
    listPhysicalLibraryLocations(session: $session) {
      name
      id
      referenceLibraryElements {
        name
        id
      }
    }
  }
`;

export const GET_DEFAULT_PRIORITY = gql`
  query getDefaultPriority($session: String!) {
    getDefaultPriority(session: $session)
  }
`;

export const LIST_WAITING_FORS = gql`
  query listWaitingFors($session: String!) {
    listWaitingFors(session: $session) {
      id
      name
      type
      priority
      minuteEstimate
      organization {
        id
        name
      }
      person {
        id
        name
      }
      blocks {
        id
        name
      }
      parentElement {
        id
        name
      }
      blockedBy {
        id
        name
      }
      lifeDomain {
        id
        name
      }
      referenceLibraryElements {
        id
        name
        type
        body
        physicalLibraryLocation {
          id
          name
        }
      }
    }
  }
`;

export const NEW_LIST_FILTERED_ELEMENTS: APICall = {
  documentNode: gql`
    query newListFilteredElements(
      $session: String!
      $type: Int!
      $filter: ListElementsFilter
    ) {
      newListFilteredElements(session: $session, type: $type, filter: $filter) {
        id
        name
        type
        priority
        topItemOfDay
        minuteEstimate
        lifeDomain {
          id
          name
        }
        parentElement {
          id
          name
        }
        isChildElement
        childNextActions {
          id
          name
        }
        childSomedayMaybes {
          id
          name
        }
        childProjects {
          id
          name
        }
        childWaitingFors {
          id
          name
        }
        blocks {
          id
          name
        }
        blockedBy {
          id
          name
        }
        referenceLibraryElements {
          id
          name
          type
          body
          physicalLibraryLocation {
            id
            name
          }
        }
      }
    }
  `,
  key: "newListFilteredElements",
};

export const LIST_ELEMENTS_FOR_DROPDOWNS: APICall = {
  documentNode: gql`
    query listElementsForDropdowns($session: String!, $types: [Int!]!) {
      listElementsForDropdowns(session: $session, types: $types) {
        id
        name
      }
    }
  `,
  key: "listElementsForDropdowns",
};

export const NEW_LIST_ELEMENTS: APICall = {
  documentNode: gql`
    query newListElements(
      $session: String!
      $types: [Int!]!
      $appendTypeToName: Boolean!
    ) {
      newListElements(
        session: $session
        types: $types
        appendTypeToName: $appendTypeToName
      ) {
        id
        name
        type
        priority
        lifeDomain {
          id
          name
        }
        parentElement {
          id
          name
        }
        isChildElement
        childNextActions {
          id
          name
        }
        childSomedayMaybes {
          id
          name
        }
        childProjects {
          id
          name
        }
        childWaitingFors {
          id
          name
        }
        referenceLibraryElements {
          id
          name
          type
          body
          physicalLibraryLocation {
            id
            name
          }
        }
      }
    }
  `,
  key: "newListElements",
};
